export enum AssetType {
    general = 'General',
    tree = 'Tree',
    bench = 'Bench',
    seat = 'Seat',
}

export enum AssetArea {
    woodland = '林地',
    seaside = '海濱',
    urbanForest = '城市森林',
    orchard = '果園'
}

export enum RecaptchaLg {
    "zhTW" = 'zh-TW',
    "zh-HK" = 'zh-TW',
    "en-US" = 'en',
    "en" = 'en',
    "ch" = "zh-CN"
}